/**
 * Footer Unilar- Interactive functionality
 * Handles accordion navigation for footer sections
 */

class Footerunilar {
  constructor() {
    this.init();
  }

  init() {
    this.setupAccordions();
    this.setupCategoriesAccordion();
    this.setupCountrySelector();
    this.setupBackToTop();
  }

  setupAccordions() {
    const accordions = document.querySelectorAll('[data-accordion]');
    
    accordions.forEach((accordion) => {
      const header = accordion.querySelector('.footer-column-header');
      
      if (header) {
        header.addEventListener('click', () => {
          // Check if mobile view (width <= 768px)
          if (window.innerWidth <= 768) {
            accordion.classList.toggle('active');
          }
        });
      }
    });

    // Handle resize to ensure proper behavior
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth > 768) {
          // Remove all active classes on desktop
          accordions.forEach((accordion) => {
            accordion.classList.remove('active');
          });
        }
      }, 250);
    });
  }

  setupCategoriesAccordion() {
    const categoriesAccordion = document.querySelector('[data-categories-accordion]');
    if (!categoriesAccordion) return;

    const trigger = categoriesAccordion.querySelector('.categories-trigger');
    const content = categoriesAccordion.querySelector('.categories-content');
    const categoryColumns = categoriesAccordion.querySelectorAll('.category-column');

    // Main categories toggle
    if (trigger && content) {
      trigger.addEventListener('click', () => {
        const isActive = categoriesAccordion.classList.toggle('active');
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        trigger.setAttribute('aria-expanded', !isExpanded);
        
        // Remove hidden attribute to allow CSS animation
        if (isActive) {
          content.removeAttribute('hidden');
        }
        // We rely on CSS visibility: hidden and height: 0 for the closed state
        // to avoid complex JS transitionend handling
      });
    }

    // Mobile accordion for individual categories
    categoryColumns.forEach((column) => {
      const heading = column.querySelector('.category-heading');
      
      if (heading) {
        heading.addEventListener('click', () => {
          // Only work on mobile
          if (window.innerWidth <= 768) {
            column.classList.toggle('active');
            const isExpanded = heading.getAttribute('aria-expanded') === 'true';
            heading.setAttribute('aria-expanded', !isExpanded);
          }
        });
      }
    });

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth > 768) {
          // Remove all active classes from category columns on desktop
          categoryColumns.forEach((column) => {
            column.classList.remove('active');
          });
        }
      }, 250);
    });
  }

  setupBackToTop() {
    const button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  setupCountrySelector() {
    const trigger = document.querySelector('.country-selector-trigger');
    const dropdown = document.querySelector('.country-dropdown');
    
    if (!trigger || !dropdown) return;

    // Toggle dropdown
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      trigger.setAttribute('aria-expanded', !isExpanded);
      
      if (isExpanded) {
        dropdown.setAttribute('hidden', '');
      } else {
        dropdown.removeAttribute('hidden');
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('hidden', '');
      }
    });

    // Close dropdown when pressing Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('hidden', '');
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new Footerunilar();
  });
} else {
  new Footerunilar();
}
